import { INJECTOR, Injector, Optional, Provider } from '@angular/core';
import {
  UserAccountInformationForm,
  IUserAccountInformationForm,
} from './user-account-information.form';
import {
  RXAP_FORM_CONTEXT,
  RXAP_FORM_DEFINITION,
  RXAP_FORM_DEFINITION_BUILDER,
  RXAP_FORM_INITIAL_STATE,
  RXAP_FORM_SUBMIT_METHOD,
  RXAP_FORM_SUBMIT_SUCCESSFUL_METHOD,
  RxapFormBuilder,
} from 'eurogard-forms';
import { DataSourceRefreshToMethodAdapterFactory } from 'eurogard-data-source';
import { UserSettingsAccordionDataSource } from '../user-settings-accordion.data-source';
import { FormContextFromActivatedRouteFactory } from 'eurogard-form-system';
import { ActivatedRoute } from '@angular/router';
import { CompanyGuiTableDataSource } from 'open-api-table-data-source/data-sources/company-gui-table.data-source';
import { CountryOptionsDataSource } from 'angular-data-sources/country-options.data-source';
import {
  SubmitUserInfoMethod
} from 'angular-components/layout/default-header/user-profile-icon/user-settings/user-account-information/submit-user-info.method';

export const FormProviders: Provider[] = [
  CompanyGuiTableDataSource,
  UserAccountInformationForm,
  CountryOptionsDataSource,
  {
    provide: RXAP_FORM_SUBMIT_SUCCESSFUL_METHOD,
    useFactory: DataSourceRefreshToMethodAdapterFactory,
    deps: [UserSettingsAccordionDataSource],
  },
  {
    provide: RXAP_FORM_SUBMIT_METHOD,
    useClass: SubmitUserInfoMethod,
  },
];
export const FormComponentProviders: Provider[] = [
  {
    provide: RXAP_FORM_DEFINITION,
    useFactory: FormFactory,
    deps: [INJECTOR, [new Optional(), RXAP_FORM_INITIAL_STATE]],
  },
  {
    provide: RXAP_FORM_CONTEXT,
    useFactory: FormContextFromActivatedRouteFactory,
    deps: [ActivatedRoute],
  },
];
export const FormBuilderProviders: Provider[] = [
  {
    provide: RXAP_FORM_DEFINITION_BUILDER,
    useFactory: FormBuilderFactory,
    deps: [INJECTOR],
  },
];

export function FormFactory(
  injector: Injector,
  state: IUserAccountInformationForm | null
): UserAccountInformationForm {
  return new RxapFormBuilder<IUserAccountInformationForm>(
    UserAccountInformationForm,
    injector
  ).build(state ?? {});
}

function FormBuilderFactory(
  injector: Injector
): RxapFormBuilder<IUserAccountInformationForm> {
  return new RxapFormBuilder<IUserAccountInformationForm>(
    UserAccountInformationForm,
    injector
  );
}
